import { Header } from "semantic-ui-react";

import React from "react";

import Flex from "../../../../../components/Flex/Flex";
import CoverImageStack from "../../../../ui/components/CoverImage/CoverImageStack";

export default function CreateProductionWorkOption({ work }) {
	return (
		<Flex alignItems="center" justifyContent="flex-start">
			<div style={{ marginRight: "1em", height: 40, width: 40 }}>
				<CoverImageStack data={work} size={45} style={{ margin: "0 auto" }} />
			</div>

			<div>
				<Header as="h5" style={{ margin: 0 }}>
					{work.name}
				</Header>
			</div>
		</Flex>
	);
}
